import {
	GET_BANNERS, CREATE_BANNER, UPDATE_BANNER, GET_ERRORS, ACTIVATE_BANNNER, DEACTIVATE_BANNER,
} from "../actions/types";

const initialState = {
	actionType: '',
	banners: [],
	totalPages: 0,
	products: [],
	error: '',
};

export default function (state = initialState, action) {
	switch (action.type) {
		case CREATE_BANNER:
			return {
				...state,
				actionType: action.type,
				closeModal: true,
				success:    'El banner fue creado exitosamente'
			};
		case UPDATE_BANNER:
			return {
				...state,
				actionType: action.type,
				closeModal: true,
				success: 'El banner fue actualizado exitosamente.'
			};
		case GET_BANNERS:
			return {
				...state,
				closeModal: true,
				actionType: '',
				banners: action.payload.banners,
				totalPages: action.payload.total_pages,
				success: 'Se obtuvieron ' + action.payload.banners.length + " banners"
			};
		case DEACTIVATE_BANNER:
			return {
				...state,
				actionType: action.type,
				closeModal: true,
				success: 'El banner fue desactivada exitosamente.'
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error:      action.payload
			};
		default:
			return state;
	}
}